import { Plugin } from '@nuxt/types';
import { initializeTheme } from '../util/themes/themeInitializer';

// @ts-ignore $vuetify DOES exist ;)
const accessor: Plugin = ({ $config, $vuetify }) => {
  initializeTheme($config, $vuetify);
};

export default accessor;
